
import config from "@/assets/config";
import routes from "@/assets/routes";
import { proyecto } from "@/mixins/proyecto.mixins.js";
import { util } from "@/mixins/util.js";
import { common } from "@/mixins/common.js";
import Toast from "@/components/fc/Toast";
export default {
  components: { Toast },
  mixins: [proyecto, util, common],
  beforeMount() {
    this.load();
  },
  mounted() {
    this.checkToken();
    document.addEventListener("keydown", this.handleEnterKey);
  },
  beforeDestroy() {
    // Asegúrate de eliminar el evento de escucha cuando se destruye el componente
    document.removeEventListener("keydown", this.handleEnterKey);
  },
  props: { token_info: Object, proyecto_id: String },
  data() {
    return {
      app: config.APP,
      currentData: {
        recordarUsuario: false,
      },
      proyecto: null,
      loading: false,
      message: "",
    };
  },
  methods: {
    handleEnterKey(event) {
      if (event.key === "Enter") {
        this.login();
      }
    },
    /**
     * Cargar la página de login
     */
    load() {
      // Purga total de la sesión anterior: store, storage, socket y headers
      // de axios. Nada de la entidad anterior debe quedar visible ni activo.
      this.$store.commit("resetAuth");
      this.$store.commit("resetCookie");
      this.$store.commit("resetToast");
      this.$store.commit("resetWorkflow");
      this.$store.commit("resetProyectoV");
      this.$store.commit("resetReports");
      this.$store.commit("resetSocket");
      this.$axios.setToken(false);
      this.$axios.setHeader("token", false);
      this.$axios.setHeader("user-id", false);

      this.$store.dispatch("loadPV", this.proyecto_id);
      this.$cookie.set(config.cookie.pv_id, this.proyecto_id);
    },
    /**
     * Comprobar el token si guardo la sesión
     */
    async checkToken() {
      try {
        if (this.token_info && Object.keys(this.token_info).length > 0) {
          // Solo auto-loguear si la cuenta se recordó en ESTA misma página de
          // entidad; una cuenta recordada de otra entidad no debe iniciar
          // sesión aquí (mezclaba sesiones del equipo de soporte).
          let pvToken = this.token_info.pv;
          if (!pvToken || !this.proyecto_id || pvToken != this.proyecto_id) {
            return;
          }
          this.currentData["id"] = this.token_info.user;
          this.currentData["clave"] = this.token_info.pass;
          await this.login(true);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async login(access) {
      try {
        if (this.$refs.formData.validate() || access) {
          this.loading = true;
          this.message = "";
          this.$axios.setHeader("web-key", config.web_key);
          let url = config.api.url + "login";
          // pv: identifica la página de login (para "recordar usuario").
          // entidad: solo se envía en páginas de entidad específica; en la
          // página genérica (config.APP.ID) la entidad se deriva de la cuenta,
          // como siempre — filtrar ahí bloquearía logins válidos.
          let payload = Object.assign({}, this.currentData);
          let entidadLogin = this.proyecto_id || this.$cookie.get(config.cookie.pv_id);
          if (entidadLogin) payload.pv = entidadLogin;
          if (entidadLogin && entidadLogin != config.APP.ID) {
            payload.entidad = entidadLogin;
          }
          let { data } = await this.$axios.post(url, payload);
          if (data.success) {
            let info = data.info;
            if (info.estado == config.estadoUsuarios.inactivo) {
              this.message = this.$t("login.innactiveAccount");
            } else {
              if (this.currentData.recordarUsuario) {
                this.$cookie.set("token_cuenta", info.token_cuenta, 30);
              }
              this.$axios.setHeader("token", info.token);
              this.$axios.setHeader("user-id", info.uid);
              this.$store.commit("setHeader", info);
              if (this.app.validarPlanes && this.app.validarPlanes == true) {
                await this.validacionPlanesEntidad(info);
              }
              
              await this.validarPeriodoContableActual();
              
              this.loading = false;
              if (info.pagina_inicio) {
                this.$router.push(`/${info.pagina_inicio}`);
              } else this.$router.push(routes.cases);
            }
          } else {
            this.message = data.message;
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response) {
          var data = error.response.data;
          this.message = data.message;
        }
        // var data = error.response.data;
        // this.message = data.message;
      } finally {
        this.loading = false;
      }
    },

    async validacionPlanesEntidad(info) {
      try {
        let espacio_utilizado = await this.getEspacioUtilizado(info.entidad);
        let espacio_disponible = Number(
          parseInt(info.total_disco) - espacio_utilizado
        );
        info["espacio_disponible"] = parseFloat(espacio_disponible.toFixed(2));
        this.$store.commit("setCuentasDisponibles", info.cuentas_disponibles);
        this.$store.commit("setEspacioDisponible", info.espacio_disponible);
        this.$store.commit("setPlanContratado", info.plan_contratado);
      } catch (error) {
        console.error("validacionPlanesEntidad", error);
      }
    },

    /**
     * Valida que exista un periodo contable para la fecha actual del sistema
     * Si el periodo no existe, lo crea automáticamente
     * Se ejecuta automáticamente cada vez que un usuario inicia sesión
     */
    async validarPeriodoContableActual() {
      try {
        const fechaActual = new Date();
        const mesActual = String(fechaActual.getMonth() + 1).padStart(2, '0');
        const añoActual = String(fechaActual.getFullYear());
        const periodoActual = `${añoActual}${mesActual}`;

        const url = `paracodes/form_periods/?codeNumber=${periodoActual}&codeSysState=NORMAL`;
        const response = await this.$axios.get(url);

        if (!response.data || !response.data.info || response.data.info.length === 0) {
          try {
            const nuevoPeriodo = await this.initParacodes('form_periods/', '0');

            const periodoData = {
              ...nuevoPeriodo,
              codeNumber: periodoActual,
              codeTitle: periodoActual,
              nombre_compuesto: periodoActual,
              active: true,
              period: periodoActual
            };

            const savePath = 'form_periods/';
            const saveResponse = await this.saveParacodes(savePath, periodoData);
            
            if (saveResponse.success) {
              console.log(`Periodo contable ${periodoActual} creado exitosamente`);
            } else {
              console.error('Error al crear el periodo:', saveResponse);
            }
            
          } catch (errorCreacion) {
            console.error('Error al crear periodo contable en login:', errorCreacion);
          }
        } else {
          const periodo = response.data.info[0];
          if (periodo.active) {
            console.log(`El periodo contable ${periodoActual} existe y está activo`);
          } else {
            console.warn(`El periodo contable ${periodoActual} existe pero no está activo`);
          }
        }

      } catch (error) {
        console.error('Error validando periodo contable en login:', error);
      }
    },
  },
};
